import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LANGS, stripLang, withLang } from "../lib/router";

const ensureMeta = (key, attrs) => {
  let el = document.head.querySelector(`meta[data-seo="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("data-seo", key);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

const ensureLink = (key, attrs) => {
  let el = document.head.querySelector(`link[data-seo="${key}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("data-seo", key);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

const SEO_ORIGIN = "https://www.pilateson.de";

const applySeoLinks = (pathname) => {
  const origin = SEO_ORIGIN;
  const base = stripLang(pathname);
  ensureLink("canonical", { rel: "canonical", href: origin + pathname });
  LANGS.forEach((l) => ensureLink(`alt-${l}`, { rel: "alternate", hreflang: l, href: origin + withLang(base, l) }));
  ensureLink("alt-default", { rel: "alternate", hreflang: "x-default", href: origin + base });
};

export function useMeta(title, description) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    if (description) {
      document.querySelector('meta[name="description"]')?.setAttribute("content", description);
    }
    applySeoLinks(pathname);
    const canonical = SEO_ORIGIN + pathname;
    ensureMeta("og-title", { property: "og:title", content: title });
    if (description) ensureMeta("og-description", { property: "og:description", content: description });
    ensureMeta("og-type", { property: "og:type", content: "website" });
    ensureMeta("og-url", { property: "og:url", content: canonical });
    ensureMeta("og-site", { property: "og:site_name", content: "PILATES ON." });
    ensureMeta("og-image", { property: "og:image", content: SEO_ORIGIN + "/images/pilates-on-og.jpg" });
    ensureMeta("twitter-card", { name: "twitter:card", content: "summary_large_image" });
    ensureMeta("twitter-title", { name: "twitter:title", content: title });
    ensureMeta("twitter-image", { name: "twitter:image", content: SEO_ORIGIN + "/images/pilates-on-og.jpg" });
    if (description) ensureMeta("twitter-description", { name: "twitter:description", content: description });
  }, [title, description, pathname]);
}
